var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab-bar clearfix"},_vm._l((_vm.navList),function(nav,index){return _c('li',{key:index,class:{
      pre: nav.targetRouterName === _vm.currentItem.targetRouterName,
    }},[_c('nav-link-item',{attrs:{"nav":nav}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }